module.exports = "/packs/016-536a77ed7ec84098a974513aab6a9997.jpg";